import http from 'hub-http/clients/apiClient';
import { queryQuickFetch } from './earlyRequestHelper';
import { EARLY_REQUESTER_KEYS } from '../constants/EarlyRequesterKeys';
const MULTI_CURRENCY_URI = 'multi-currency/v2';
export const fetchCurrencyInfo = () => queryQuickFetch(EARLY_REQUESTER_KEYS.CURRENCIES, () => http.get(`${MULTI_CURRENCY_URI}/currencies/information`));
export const fetchPreferredCurrency = () => queryQuickFetch(EARLY_REQUESTER_KEYS.PREFERRED_CURRENCY, () => http.get(`${MULTI_CURRENCY_URI}/currencies/preferred-currencies`));
export const setPreferredCurrency = ({
  currencyCode
}) => http.put(`${MULTI_CURRENCY_URI}/currencies/preferred-currencies`, {
  data: {
    preferredCurrency: currencyCode
  }
});
export const deletePreferredCurrency = () => http.delete(`${MULTI_CURRENCY_URI}/currencies/preferred-currencies`);